import React, { Fragment } from "react";
import { Route } from "react-router";
import ScrollTopOnUpdate from "./ScrollTopOnUpdate";
import RefreshStateManager from "./RefreshStateManager";
import EnhanceRouter from "./EnhanceRouter";

const AppRouter = ({ children }) => (
  <Fragment>
    <Route
      render={({ location }) => <ScrollTopOnUpdate location={location} />}
    />
    <Route
      render={({ location, history }) => (
        <RefreshStateManager location={location} history={history} />
      )}
    />
    {children}
  </Fragment>
);

export default EnhanceRouter(AppRouter);
